import { Component, Input } from '@angular/core';
import { Socio } from '../socio';

@Component({
    selector: 'sgt-socio-view',
    templateUrl: './socio-view.component.html',
    styleUrls: ['./socio-view.component.less']
})
export class SocioViewComponent {
    @Input() socios: Socio[];
    @Input() emptyText = 'Nenhum sócio encontrado';
}
